// extracted by mini-css-extract-plugin
export default {"container":"FLpzY_container","content-area":"rRbbA_content-area","right-text-wrapper":"c6srh_right-text-wrapper"};